import React from 'react';
import ListingCard from '../../components/ListingCard/ListingCard'; // adjust path if needed
import css from './ListingPage.module.css';
import Slider from 'react-slick';
import BrandIconCard from '../../components/BrandIconCard/BrandIconCard';
import { FormattedMessage } from 'react-intl';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <BrandIconCard type="slicknext" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <BrandIconCard type="slickback" />
    </div>
  );
}

function RelatedListing({ listings,favoriteButton, onToggleFavorites,loading,onUpdateFavorites, 
  handleToggleFavorites,
  location,history,routes,currentUser,reviews,relatedListingsReviews,realatedList
 }) {
 
  if (loading) {
    return <div><FormattedMessage id="RelatedListing.loadingListings" /> </div>;
  }

  if (!listings || listings.length === 0) {
    return <div><FormattedMessage id="RelatedListing.noRelatedListings" /></div>;
  }
  let settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    autoPlay: true,
    autoplaySpeed: 3000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };  

  const totalReviews = reviews?.length || 0; 
  const totalRating =
    reviews?.reduce((sum, review) => {
      const rating = review?.attributes?.rating;
      return sum + (typeof rating === 'number' ? rating : 0);
    }, 0) || 0;

  const averageRating = totalReviews > 0 ? (totalRating / totalReviews).toFixed(1) : '0';
  return (
    <div className={css.relatedListing}>
      <div className={css.relatedHeading}><FormattedMessage id="RelatedListing.moreStays" /></div>
      <div className={css.listingCards}>
        <Slider {...settings}>
          {listings.map(listing => (
            <ListingCard key={listing.id.uuid} listing={listing} 
            realatedList={realatedList}
            relatedListingsReviews={relatedListingsReviews}
            handleToggleFavorites={handleToggleFavorites}
            onUpdateFavorites={onUpdateFavorites}
            location={location}
            favoriteButton={favoriteButton}     
              history={history} // Add history prop
              routes={routes} // Add routes prop 
              onToggleFavorites={onToggleFavorites}
              currentUser={currentUser}
              averageRating={averageRating}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default RelatedListing;
